module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Eunice Moyle, Sabrina Moyle, Shana Faust, Joseph De Leo\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Eunice Moyle, with Sabrina Moyle, co-founded Hello!Lucky in 2003 with a vintage Vandercook printing press. She is also co-author of "), _c('I', [_vm._v("Handmade Hellos")]), _vm._v(". She lives in San Francisco.Shana Faust is a freelance stylist and the former Deputy Style Editor of "), _c('I', [_vm._v("Martha Stewart Weddings")]), _vm._v(". She lives in New York City."), _c('br'), _c('br'), _vm._v("Joseph De Leo is a food and still life photographer based in New York City. His work has appeared in numerous books and magazines.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6Vl29s/tc-custom/9781452110011.jpg?1705766127402",
      "alt": "This image is the cover for the book Handmade Weddings"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Handmade Weddings\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this delightful book, the founders of Hello!Lucky join forces with a renowned wedding stylist to bring you over fifty gorgeous DIY projects. ")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Handcrafted details are at the heart of a beautiful wedding adding charm, meaning, and style."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Whether you favor a modern, classic look or a retro, homespun flavor, in "), _c('i', [_vm._v("Handmade Weddings")]), _vm._v(" you’ll find plenty of crafts and inspiration suited to your taste—from vintage key save-the-dates to delicate paper wreaths to silhouette bride and groom signs."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" At the front of the book you’ll find guidance on choosing a look, sourcing materials, and working out timelines. Then, each of the fifty projects are fully explained with photos, how-to diagrams, and step-by-step directions."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Clever, creative, and budget-friendly, "), _c('i', [_vm._v("Handmade Weddings")]), _vm._v(" is the perfect handbook for the bride looking to style her day her way. \n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0